/**
 * Generates a random string of predefineddefined length
 * Example of usage: temporary uid
 */
export const generateRandomString = (length = 12) => {
  return [...Array(length)]
    .map(() => Math.random().toString(36)[2])
    .join('')
    .toUpperCase();
};

/**
 * Convert camelCase to snake_case
 */
const camelToSnakeCase = (str) => {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
};

/**
 * Recursively convert keys from camelCase to snake_case in an object or array
 */
export const convertKeysToSnakeCase = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToSnakeCase(item));
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const snakeKey = camelToSnakeCase(key);
      acc[snakeKey] = convertKeysToSnakeCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
};

/**
 * Convert snake_case to camelCase
 */
const snakeToCamelCase = (str) => {
  return str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());
};

/**
 * Recursively convert keys from snake_case to camelCase in an object or array
 */
export const convertKeysToCamelCase = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertKeysToCamelCase(item));
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const camelKey = snakeToCamelCase(key);
      acc[camelKey.replace(/_/g, '')] = convertKeysToCamelCase(obj[key]);
      return acc;
    }, {});
  }
  return obj;
};

export const encodeBase64 = (obj) => btoa(JSON.stringify(obj)).replace(/=*$/, '');

export const decodeBase64 = (str) => JSON.parse(str ? atob(str) : '{}');

export const genUnsignedJWT = (payload = {}) => {
  const header = { alg: 'RS256', typ: 'JWT' };

  const encodedHeader = encodeBase64(header);
  const encodedPayload = encodeBase64(payload);

  return [encodedHeader, encodedPayload].join('.');
};
